import React from 'react';
import { connect } from 'react-redux';
import { Select, Box, Type } from '@nerdwallet/currency';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import { inputsSelector } from '../../../lib/selectors/home-affordability-calculator-selectors';
import { HomeAffordabilityInput, inputOnChange } from '../../../lib/utils';
import { firstVaLoanOption as VALoanOptions } from '../hacControlOptions';

import styles from '../hac-control-panel/hac-control-panel.module.less';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const VeteranMortgageInput: React.FC<HomeAffordabilityInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  className = '',
  tooltip = '',
  fullWidth,
}) => {
  const value = inputs?.firstVaLoan;
  const errorMessage = validations?.firstVaLoan?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_s',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'firstVaLoan',
      calculator: HOME_AFFORDABILITY,
    });
  };

  return (
    <Box>
      <Select
        options={VALoanOptions}
        value={value}
        error={error}
        errorMessage={errorMessage}
        onChange={onInputChange}
        label={label}
        className={className}
        tooltip={tooltip}
        fullWidth={fullWidth}
      />
      <Type size="1" className={styles.veteranMortgageNote}>
        Nerdy insight: VA loans accept down payments as low as 0%
      </Type>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(VeteranMortgageInput);
